import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';  // 自定義的 HTTP 請求函數
import { statusCheck } from '@/store/public'; // 檢查 API 響應狀態的函數
import Swal from 'sweetalert2'


//此pinia用於顯示Table列表以及下載csv
export const usePaymentListStore = defineStore('paymentList', {
  state: () => ({
    payments: [],
    totalEntries: 0,
    currentPage: 1,
    itemsPerPage: 10,
    filters: {
      driverName: '',
      driverID: '',
      plateNumber: '',
      fromDate: '',
      toDate: '',
      paymentMethod:'Cash',
      sort_by:'created_at',
      order:'desc',
    },
  }),
  actions: {
    async fetchPayments(page = this.currentPage, perPage = this.itemsPerPage) {
      const url = `/api/admin/payment/list`;
      let params = new URLSearchParams();

      params.append('per_page', perPage);
      params.append('page', page);

      // 格式化日期函數
      const formatDate = (date) => {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      };

      // 添加過濾器參數
      if (this.filters.driverName) params.append('driver_name', this.filters.driverName);
      if (this.filters.driverID) params.append('driver_id', this.filters.driverID);
      if (this.filters.plateNumber) params.append('plate_number', this.filters.plateNumber);
      if (this.filters.fromDate) params.append('from', formatDate(this.filters.fromDate));
      if (this.filters.toDate) params.append('to', formatDate(this.filters.toDate));
      if (this.filters.paymentMethod) params.append('payment_method', this.filters.paymentMethod);
      if (this.filters.sort_by) params.append('sort_by', this.filters.sort_by);
      if (this.filters.order) params.append('order', this.filters.order);

      try {
        const response = await useHttp().post(`${url}?${params.toString()}`);
        if (statusCheck(response.data)) {
          this.payments = response.data.payments || [];
          this.totalEntries = response.data.total || 0;
          this.currentPage = response.data.current_page || 1;  // 確保正確設置當前頁面
        } else {
          console.error('Failed to fetch payments:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching payments:', error);
        throw error;
      }
    },
    async undoPayment(paymentId) {
      const url = `/api/admin/payment/undo`;
      const payload = {
        id: paymentId // 支付ID
      };
      try {
        const response = await useHttp().post(url, payload);
        if (statusCheck(response.data)) {
           Swal.fire({
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
        }
      } catch (error) {
        console.error('Error undoing payment:', error);
        throw error;
      }
    },
    async remitCSV() {
      const url = `/api/admin/payment/export_csv`;
      let params = new URLSearchParams();

      // 格式化日期函數
      const formatDate = (date) => {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      };

      // 添加過濾器參數
      if (this.filters.driverName) params.append('driver_name', this.filters.driverName);
      if (this.filters.driverID) params.append('driver_id', this.filters.driverID);
      if (this.filters.plateNumber) params.append('plate_number', this.filters.plateNumber);
      if (this.filters.fromDate) params.append('from', formatDate(this.filters.fromDate));
      if (this.filters.toDate) params.append('to', formatDate(this.filters.toDate));
      if (this.filters.paymentMethod) params.append('payment_method', this.filters.paymentMethod);

      try {
        const response = await useHttp().get(`${url}?${params.toString()}`);
        if (statusCheck(response.data)) {
          // 創建 Blob 物件
        const blob = new Blob([response.data], { type: 'text/csv' });
        
        // 使用 URL.createObjectURL 生成下載鏈接
        const downloadUrl = URL.createObjectURL(blob);
        
        // 創建一個隱藏的 <a> 標籤並觸發點擊下載
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', 'payments.csv'); // 設置下載的檔名
        document.body.appendChild(link);
        link.click();
        
        // 移除連結
        document.body.removeChild(link);
        
        // 釋放 URL 物件
        URL.revokeObjectURL(downloadUrl);

        } else {
          console.error('Failed to fetch payments:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching payments:', error);
        throw error;
      }
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchPayments(page); // 傳遞頁碼以獲取對應頁面的數據
      }
    },
  },
  getters: {
    paginatedData(state) {
      // 在 API 返回完整數據的情況下，不需要手動分頁
      return state.payments;
    },
    totalPages(state) {
      return Math.ceil(state.totalEntries / state.itemsPerPage);
    },
  },
});
